import { render, staticRenderFns } from "./PermissionsExpansionPanel.vue?vue&type=template&id=79ccf57b&scoped=true&"
import script from "./PermissionsExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./PermissionsExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsExpansionPanel.vue?vue&type=style&index=0&id=79ccf57b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ccf57b",
  null
  
)

export default component.exports